import React from 'react';

const About = () => {
  return (
    <section className='section bg-secondary' id='about'>
      <div className='container mx-auto'>
        <div className='flex flex-col xl:flex-row gap-24'>
          {/* <img
            className='object-cover h-full w-[566px] md:mx-auto lg:mx-0 rounded-2xl'
            src={Image}
            alt=''
          /> */}
          <div className="card bg-base-100 shadow-xl md:mx-auto lg:mx-0 px-2 lg:px-10">
            <div className="card-body space-y-4">
              <h2 className="card-title text-2xl"> Technologies and Skills </h2>
              <div className='py-2 '>
                <h4 className='font-bold pb-3'>Expert:</h4>
                <p>HTML 5, CSS 3, Tailwind CSS , Bootstrap 5, JavaScript (ES6), React.Js, React-Bootstrap,React-router, Authentication.</p>
              </div>
              <div className='py-2 '>
                <h4 className='font-bold pb-3'>Comfortable:</h4>
                <p>Mongodb , Express , Node , React Query , Redux </p>
              </div>
              <div className='py-2 '>
                <h4 className='font-bold pb-3'>Tools & Others:</h4>
                <p>Git, Github,VScode, Figma, Firebase, Netlify , Chrome Dev Tools  .</p>
              </div>
            </div>
          </div>
          <div className='flex flex-col items-center text-center lg:items-start lg:text-left'>
            <div className='flex flex-col '>
              <h2 className='text-3xl lg:text-4xl font-medium lg:font-extrabold mb-3  relative before:absolute before:opacity-40 before:-top-[2rem] before:hidden before:lg:block'>
                Emtiaz Emon
              </h2>
              <p className='mb-4 text-accent'>
                Frontend Web Developer
              </p>
              <hr className='mb-8 opacity-5' />
              <div>
                <p>I'm Jr Front end developer. Recently I know HTML, CSS, Tailwind, Bootstrap, JavaScript, React, Node, Mongo, Express, and much more. I have experience in building projects on the MERN stack.
                </p>
              </div>
              <hr className='mb-8 opacity-5' />
              <div>
                <p>I have learned, from the very start, the importance of passion, dedication, confidence, and time management.
                </p>
              </div>
              <div className="card bg-base-100 shadow-xl pb-5 ">
                <div className="card-body space-y-3">
                  
                  <div className='py-3 '>
                    <h4 className='font-bold pb-2'>Present </h4>
                    <p>After getting auto pass in HSC (2020) I'm not continue my study . Now i'm try to get scholarship and learn something special . </p>
                  </div>
                </div>
              </div>
            </div>
            <button className='btn btn-md bg-accent hover:bg-secondary-hover transition-all mt-5'>
              <a
                className='flex justify-between items-center w-full text-gray-300'
                href='mailto:emtiazhossainrzs@gmail.com' target="_blank" rel="noopener noreferrer"
              >
                Contact Me
              </a>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
